import { PropsWithChildren, ReactNode, useCallback, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { ArrowCollapse } from '../Icons';

type CollapseProps = PropsWithChildren<{
  title: ReactNode;
  description?: string;
  actions?: ReactNode;
}>;

export const CollapseV2 = ({
  title,
  description,
  actions,
  children,
}: CollapseProps) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(true);

  const toggleIsExpanded = useCallback(() => {
    setIsExpanded((isExpanded) => !isExpanded);
  }, []);

  return (
    <div
      className={`${isExpanded && "h-auto bg-[url('assets/icons/grey_dot.svg')] bg-repeat-y"} pb-5`}
      style={{ backgroundPositionX: '6px' }}
    >
      <div className="row-auto flex h-5 w-full cursor-pointer items-center gap-2">
        <div
          className="flex flex-row items-center gap-2"
          onClick={toggleIsExpanded}
        >
          <ArrowCollapse
            className={`transition-all duration-300 ease-in-out ${isExpanded ? 'rotate-0' : 'rotate-180'}`}
          />
        </div>
        <div
          className="flex h-full min-h-10 w-full items-center justify-between gap-4 rounded-md px-2 transition-colors hover:bg-lightPurple"
          onClick={toggleIsExpanded}
        >
          <div className="flex items-center">
            <span className="mr-1 text-sm font-bold">{title}</span>
            {description && <span className="text-sm">{description}</span>}
          </div>
          <div className="flex h-full flex-row items-center gap-4">
            {actions}
          </div>
        </div>
      </div>
      <div
        className={twMerge(
          'transition-height ml-5 mt-5 h-0 overflow-x-auto duration-300 ease-in-out',
          isExpanded && 'h-auto',
        )}
      >
        {children}
      </div>
    </div>
  );
};
